// extracted by css-extract-rspack-plugin
export default {"vulnSummary":"LMWtmxYALsIitwOJ"};